"use client";

import { Page } from "@/app/common/page-component";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { useRef } from "react";
import { Faq } from "./landing-page/faq-section";
import { FeaturesV2 } from "./landing-page/features-v2";
import { HeroSectionV2 } from "./landing-page/hero-section-v2";
import { ScrollPad } from "./landing-page/scroll-pad";
import { SignUpSection } from "./landing-page/sign-up-section";
import { TestimonialsSection } from "./landing-page/testimonials-section";
import { VisionSection } from "./landing-page/vision-section";

export default function LandingPage() {
    const section1 = useRef<HTMLDivElement>(null);
    const section2 = useRef<HTMLDivElement>(null);
    const section3 = useRef<HTMLDivElement>(null);
    const section4 = useRef<HTMLDivElement>(null);
    const startSection = useRef<HTMLDivElement>(null);

    return (
        <Page withFooter>
            <HeroSectionV2
                onScrollDownAction={(v) => {
                    if (v === "blockchain-payouts") {
                        section1.current?.scrollIntoView({ behavior: "smooth" });
                    } else if (v === "split-payments") {
                        section2.current?.scrollIntoView({ behavior: "smooth" });
                    } else if (v === "co-ownership-campaigns") {
                        section3.current?.scrollIntoView({ behavior: "smooth" });
                    } else if (v === "content-marketplace") {
                        section4.current?.scrollIntoView({ behavior: "smooth" });
                    } else if (v === "start-exploring") {
                        startSection.current?.scrollIntoView({ behavior: "smooth" });
                    }
                }}
            />
            <div ref={startSection}>
                <TestimonialsSection />
            </div>
            <LargeHeadingSection />
            <FeaturesV2
                refs={{
                    "blockchain-payouts": section1,
                    "split-payments": section2,
                    "co-ownership-campaigns": section3,
                    "content-marketplace": section4,
                }}
            />
            <ScrollPad />
            <SignUpSection />
            <VisionSection />
            <Faq />
        </Page>
    );
}

function LargeHeadingSection() {
    return (
        <div className="my-32 md:my-44">
            <div className="mx-auto max-w-xl">
                <div className="text-balance text-center font-bold text-4xl leading-tight md:text-5xl">
                    Join the <span className="text-accent-flashy">Financial Hub</span> for Creators
                </div>
                <div className="mt-8 text-balance text-center text-muted-foreground">
                    Backed by a Community Driving 3.9B Monthly Views and 181M Followers, Talentir Grows Day by Day
                    Thanks to the Fastest Payouts and the Lowest Fees in the Industry.
                </div>
                <div className="mt-8 flex justify-center">
                    <Button asChild>
                        <Link
                            href="https://talentir-com.pipedrive.com/scheduler/BplO81F0/keep-more-get-paid-faster-take-full-control-of-your-revenue"
                            target="_blank"
                        >
                            Let's Talk
                        </Link>
                    </Button>
                </div>
            </div>
            <StatisticsSection />
        </div>
    );
}

function StatisticsSection() {
    return (
        <div className="mx-auto mt-32 max-w-4xl px-4 md:mt-44">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
                <div className="text-center">
                    <div className="font-bold text-6xl">3.9B</div>
                    <div className="mt-4 text-balance text-muted-foreground">Monthly Views</div>
                </div>
                <div className="text-center">
                    <div className="font-bold text-6xl">181M</div>
                    <div className="mt-4 text-balance text-muted-foreground">Total Followers</div>
                </div>
                <div className="text-center">
                    <div className="font-bold text-6xl">5</div>
                    <div className="mt-4 text-balance text-muted-foreground">Continents We Operate In</div>
                </div>
            </div>
        </div>
    );
}
